@use '@/styles/tokens' as *;

.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.dragger {
  :global(.ant-upload) {
    border-radius: 10px;
  }
}

.error :global(.ant-upload.ant-upload-drag) {
  border-color: $color-error-900;
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px;
  color: var(--text-muted);
}

.help {
  margin: 0;
  font-size: 14px;
  text-align: center;
  white-space: pre-line;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  gap: 12px;
}

.tile {
  position: relative;
  aspect-ratio: 1;
  overflow: hidden;
  border: 1px solid var(--border-subtle);
  border-radius: 10px;
  background: var(--surface-muted);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.tileRemove {
  position: absolute;
  top: 4px;
  right: 4px;
}

.tileLoading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: var(--text-muted);
}

.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid var(--border-subtle);
  border-radius: 10px;
}

.rowIcon {
  flex-shrink: 0;
  color: var(--text-secondary);
}

.rowBody {
  flex: 1 0 0;
  min-width: 0;
}

.rowName {
  font-size: 14px;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rowMeta {
  font-size: 12px;
  color: var(--text-muted);
}

.bar {
  height: 4px;
  margin-top: 6px;
  border-radius: 999px;
  background: var(--surface-muted);

  span {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: $color-neutral-950;
    transition: width 0.2s ease;
  }
}

.rowError {
  font-size: 12px;
  color: $color-error-900;
}

.retry,
.rowRemove {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: none;
  background: none;
  color: var(--text-secondary);
  cursor: pointer;
}
